import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import { UtilityModule } from "./modules/utility/utility.module";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatTabsModule } from "@angular/material/tabs";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { IonicModule } from "@ionic/angular";
import { AppComponent } from "./app.component";
import { AdminDashModule } from "./modules/admin/admin-dash.module";
import { ActionComponent } from "./modules/provider/action/action.component";
import { ApplicationsComponent } from "./modules/provider/applications/applications.component";
import { ProviderLayoutComponent } from "./modules/provider/layout/provider-layout.component";
import { ProviderDashComponent } from "./modules/provider/provider-dash/provider-dash.component";
import { AccountChangeRequestComponent } from "./modules/user/account-change-request/account-change-request.component";
import { AccountComponent } from "./modules/user/account/account.component";
import { AllocationComponent } from "./modules/user/allocation/allocation.component";
import { BiddingComponent } from "./modules/user/bidding/bidding.component";
import { FixedRateBidComponent } from "./modules/user/fixed-rate-bid/fixed-rate-bid.component";
import { HistoryComponent } from "./modules/user/history/history.component";
import { LayoutComponent } from "./modules/user/layout/layout.component";
import { LoginComponent } from "./modules/user/login/login.component";
import { MarketComponent } from "./modules/user/market/market.component";
import { NotificationComponent } from "./modules/user/notification/notification.component";
import { PendingApprovalComponent } from "./modules/user/pending-approval/pending-approval.component";
import { ProfileComponent } from "./modules/user/profile/profile.component";
import { RebidComponent } from "./modules/user/rebid/rebid.component";
import { RegisterComponent } from "./modules/user/register/register.component";
import { ReportComponent } from "./modules/user/report/report.component";
import { UpdateFixedRateBidComponent } from "./modules/user/update-fixed-rate-bid/update-fixed-rate-bid.component";
import { UserModule } from "./modules/user/user.module";
import { WalletComponent } from "./modules/user/wallet/wallet.component";
import { WelcomeScreenComponent } from "./modules/user/welcome-screen/welcome-screen.component";
import { UtilityWelcomeScreenComponent } from "./modules/user/utility-welcome-screen/utility-welcome-screen.component";
import { CircleComponent } from "./modules/utility/circle/circle.component";
import { DashboardComponent } from "./modules/utility/dashboard/dashboard.component";
import { UserWalletComponent } from "./modules/user/user-wallet/user-wallet.component";
import { BuyTokensComponent } from "./modules/user/buy-tokens/buy-tokens.component";
import { RedeemTokensComponent } from "./modules/user/redeem-tokens/redeem-tokens.component";
import { SmartMeterDataComponent } from "./modules/utility/smart-meter-data/smart-meter-data.component";
import { UtilityDashboardComponent } from "./modules/utility/utility-dashboard/utility-dashboard.component";
import { NavbarComponent } from "./modules/utility/navbar/navbar.component";
import { BidHistoryComponent } from "./modules/utility/bid-history/bid-history.component";
import { SettlementComponent } from "./modules/utility/settlement/settlement.component";
import { AuthInterceptor } from "./shared/interceptors/auth.interceptor";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ProfileComponent,
    RegisterComponent,
    MarketComponent,
    BiddingComponent,
    AllocationComponent,
    WelcomeScreenComponent,
    UtilityWelcomeScreenComponent,
    LayoutComponent,
    ProviderLayoutComponent,
    PendingApprovalComponent,
    HistoryComponent,
    FixedRateBidComponent,
    RebidComponent,
    UpdateFixedRateBidComponent,
    NotificationComponent,
    ReportComponent,
    AccountComponent,
    AccountChangeRequestComponent,
    ActionComponent,
    ApplicationsComponent,
    ProviderDashComponent,
    WalletComponent,
    UserWalletComponent,
    BuyTokensComponent,
    RedeemTokensComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatDialogModule,
    CommonModule,
    MatTabsModule,
    BrowserAnimationsModule,
    IonicModule.forRoot({}),
    UtilityModule,
    SharedModule,
    UserModule,
    AdminDashModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
